var _rect, _path, _path2;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgWorkers = function SvgWorkers(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.3,
    viewBox: "0 0 24 18",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.7,
    height: 2.7,
    x: 0.65,
    y: 14.65,
    rx: 1.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6V1h-4v5M2 15c-.017-4.91 1.5-10.5 8-12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.015 14.5h20c.167-3.167-1.015-11-8.5-11.5"
  })));
};
export { SvgWorkers as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyNCAxOCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS4zIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB4PSIwLjY1IiB5PSIxNC42NSIgd2lkdGg9IjIyLjciIGhlaWdodD0iMi43IiByeD0iMS4zNSIgLz4KPHBhdGggZD0iTTE0IDZWMUgxMFY2IiAvPgo8cGF0aCBkPSJNMi4wMDAxOCAxNUMxLjk4MzEyIDEwLjA5MDkgMy41IDQuNSAxMCAzIiAvPgo8cGF0aCBkPSJNMi4wMTQ4OSAxNC40OTk4SDIyLjAxNDlDMjIuMTgxNiAxMS4zMzMxIDIxIDMuNSAxMy41MTQ5IDIuOTk5NzYiIC8+Cjwvc3ZnPgo=";